import { createSelector, type OutputSelector } from 'reselect';
import { createHook } from '../index.tsx';
import type { State } from '../types.tsx';

const getTreeViewOnboarding = (state: State) => state.treeViewOnboarding;

export const getTreeViewOnboardingSpotlightDismissed: OutputSelector<
	State,
	boolean | undefined,
	(res: { spotlightDismissed?: boolean }) => boolean | undefined
> = createSelector(
	getTreeViewOnboarding,
	(treeViewOnboarding) => treeViewOnboarding.spotlightDismissed,
);

export const useTreeViewOnboardingSpotlightDismissed: () => boolean | undefined = createHook(
	getTreeViewOnboardingSpotlightDismissed,
);
